import React from 'react';
import {Card} from "antd";
import {compose} from "redux";
import {connect} from "react-redux";
import {withLoading} from "../../Boilerplate/deferLoaderHoc";
import {TaskForm} from "./TaskForm";
import {getTask, updateTask} from "../../../actions/tasks";

const TaskEdit = props => {
  const { task, projectid, onSubmit, onCancel } = props;
  return <Card title='Task Details' className={'edit-view'}>
    <TaskForm projectid={projectid} task={task} onCancel={onCancel} onSubmit={onSubmit}/>
  </Card>;
};

export default compose(
  connect(
    (state, props) => {
      let task = state.view.subview.data[props.match.params.taskId];
      if (!task) return { loading: true };
      return { task: task.resource, projectid: props.match.params.id };
    },
    (dispatch, props) => ({
      loader: () => dispatch(getTask(props.match.params.id, props.match.params.taskId)),
      onSubmit: (task) => {
        dispatch(updateTask(props.match.params.id, task));
        props.history.goBack();
      },
      onCancel: () => props.history.goBack()
    })
  ),
  withLoading
)(TaskEdit);



// WEBPACK FOOTER //
// ./src/components/Projects/Tasks/TaskEdit.js